module.exports = __webpack_public_path__ + "img/Using_Computer.fccfa540.jpeg";